import {useTranslation} from 'react-i18next';

import {Box, TextField, useTheme} from '@mui/material';

import {InfoBanner} from '../../../../../../components/InfoBanner/InfoBanner';
import {getFieldStyle} from '../../../../../../layouts/theme/FieldStyles';


export interface Props {
  education: string;
  onEducationChange: (value: string) => void;
}

export const WorkforceProfileWizardEducationStep = ({education, onEducationChange}: Props) => {
  const theme = useTheme();
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage.wizard.sections.education'});

  return (
    <Box>
      <InfoBanner text={t('guidance')} sx={{mb: 2}} />
      <TextField
        fullWidth
        multiline
        minRows={3}
        size='small'
        label={t('label')}
        value={education}
        onChange={(event) => onEducationChange(event.target.value)}
        sx={getFieldStyle(theme)}
      />
    </Box>
  );
};
